export class UserModel {
    constructor() { }

    ID: string;
    Email: string;
    FirstName: string;
    LastName: string;
    FullName: string;
    OrganizationID: string;
    OrganizationName: string;
    Password?: string;
    RoleID: number;
    UserStatus: number;
    IsProfileUpdated?: boolean;
    IsWidgetAdded?: boolean;
    ImageReferenceId: string;
    SignUpMethod: number;
    AddedBy: string;
    Signature: { IsEnabledSign: boolean, Value: string };
    Timezone: { IsDefaultTimezone: boolean, SelectedTimeZone: string };
    NotificationEnabled: boolean;
    CreatedDateTime: string;
    UpdatedDateTime: string;
    Channel_Wishlist: number[];
    EmailNotifcation: boolean;
}

export enum UserStatus {
    ACTIVE = 1,
    LOCKED,
    PENDING,
}

export enum ChannelUserStatus {
    ACTIVE = 1,
    INACTIVE,
    PENDING,
    DELETED,
    DISABLED
}

export interface OrganizationModel {
    ID: string;
    Name: string;
    Email: string;
    Status: number;
    User_Count: string;
    Created_At: string;
    Updated_At: string;
    Plan_Type: number;
    Plan_Name: number;
    Added_By: string;
}

export const mapToOrganizationModel = (x): OrganizationModel => {

    return {
        ID: x.organization_id,
        Name: x.name,
        Email: x.email,
        Status: x.status,
        User_Count: x.user_count,
        Created_At: x.created_at,
        Plan_Type: x.plan_type,
        Plan_Name: x.plan_name,
        Updated_At: x.updated_at,
        Added_By: x.added_by
    }
}

export const mapToChannelUser = (x: any): UserModel => {
    return {
        ID: x.id,
        Email: x.email,
        FirstName: x.first_name,
        LastName: x.last_name,
        FullName: x.first_name + " " + x.last_name,
        OrganizationID: x.organization_id,
        OrganizationName: x.organization_name,
        Password: x?.password ? x.password : "",
        RoleID: !!x.roleId ? x.roleId : x.role,
        UserStatus: x.status,
        IsProfileUpdated: x?.user_profile_update ? x.user_profile_update : false,
        IsWidgetAdded: x?.widget_setup ? x.widget_setup : false,
        ImageReferenceId: x.profile_image,
        SignUpMethod: x.sign_up_method,
        AddedBy: x.added_by,
        Signature: { IsEnabledSign: x.signature.is_enable_sign, Value: x.signature.value },
        Timezone: { IsDefaultTimezone: x.timezone.is_default_timezone, SelectedTimeZone: x.timezone.selected_timezone },
        NotificationEnabled: x.web_notification,
        CreatedDateTime: x.created_at,
        UpdatedDateTime: x.updated_at,
        Channel_Wishlist: x.channel_wishlist,
        EmailNotifcation: x?.email_notification,
    }
}

export enum sysAdminPlanType {
    TRIAL = 1,
    MONTHLY = 2,
    YEARLY = 3,
    ONE_TIME = 4,
}

export enum SignUpType {
    SystemAdminSignUp = 1,
    DirectBusinessEmailSignUp = 2,
    DirectSocialSignUp = 3,
    InviteBusinessEmailSignUp = 4,
    InviteSocialSignUp = 5,
    FalkonSMSSignUp = 6
}

export class SmsUserDetailsModel {
    FirstName: string;
    LastName: string;
    OrganizationName: string;
    PhoneNumber: string;
    PhoneNumberID: string;
}
